<!--
 * @Author: your name
 * @Date: 2020-08-03 11:26:15
 * @LastEditTime: 2021-01-13 16:13:39
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\lib\ui\components\form\form-widget-table\form-widget-table.vue
-->
<template>
  <div class="form-widget-table form-item">
    <x-proxy-form-item
    :showRequired="showRequired"
    :label="widget.label"
    :processTitle="widget.processTitle"
    :validatorRules="validatorRules"
    :validateKey="validateKey"
    :validateInfo="validateInfo"
    :disabled="widget.readOnly">
      <div class="table-box" :class="tableData && tableData.length <= 3 && renderSence === 'read' ? 'list-btn-margin' : ''">
        <template v-for="(item, index) in computedRenderTableData">
          <form-list-card
            :key="index"
            :columns="computedRenderCols"
            :data="item"
            :inTable="true"
            @view-detail="viewDetail($event, index)"
          ></form-list-card>
        </template>
        <x-empty v-if="showEmpty"></x-empty>
        <div class="list-btn">
          <div v-if="tableData && tableData.length > 3" class="check-all" @click="viewAllData">
            <x-svg-icon name="x-lib-more"></x-svg-icon>
            查看全部
          </div>
          <div v-if="!widget.readOnly && renderSence === 'edit'" class="add-new" @click="addItemData">
            <x-svg-icon name="x-lib-add"></x-svg-icon>
            添加记录
          </div>
        </div>
      </div>
    </x-proxy-form-item>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import FormListCard from '../form-list-card'

export default {
  name: 'FormWidgetTable',
  mixins: [FormWidgetConfigMixin],
  inject: ['$compRouter'],
  components: {
    FormListCard
  },
  props: {
    len: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  computed: {
    computedRenderCols() {
      return this.widget.tableColumn.filter((col) => {
        return !col.hidden
      })
    },
    computedRenderTableData() {
      return this.tableData.slice(0, this.len)
    },
    showEmpty: function () {
      return (!this.computedRenderTableData || this.computedRenderTableData.length === 0)
    }
  },
  watch: {
    formValue: {
      handler: function(newValue) {
        this.tableData = Array.isArray(newValue) ? newValue : []
        this.$formEventEmit('change', this.tableData)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    viewDetail(e, index) {
      this.$compRouter.push('TableItemDetail', {
        key: `${this.propKey}.${index}`,
        widgetConfig: this.widget,
        value: e,
        inTable: true,
        tableUUID: this.widget.uuid,
        formData: this.formData,
        formId: this.globalData.formId,
        formConfigList: this.formConfigList
      })
    },
    viewAllData() {
      this.$compRouter.push(this.$options.name, {
        key: this.propKey,
        widgetConfig: this.widget,
        value: this.formValue,
        formData: this.formData,
        formId: this.globalData.formId,
        formConfigList: this.formConfigList
      })
    },
    addItemData() {
      this.$compRouter.push('TableItemDetail', {
        key: `${this.propKey}.add`,
        widgetConfig: this.widget,
        inTable: true,
        tableUUID: this.widget.uuid,
        formData: this.formData,
        formId: this.globalData.formId,
        formConfigList: this.formConfigList
      })
    }
  }
}
</script>

<style lang="scss">
.form-widget-table {
  .list-btn-margin {
    margin-bottom: 0.57rem;
  }
  .table-box {
    .x-empty {
      padding: 1.571rem 0;
    }
    .list-card {
      margin-bottom: 0.57rem;
      box-shadow: 0px 0px 8px 0px #EBEEF5;
    }
    .list-btn {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: -0.57rem;
      margin-top: -0.57rem;
      color: #303133;
      .x-svg-icon {
        display: flex;
        align-items: center;
      }
      .check-all {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: normal;
        height: 3.571rem;
      }
      .add-new {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: normal;
        height: 3.571rem;
      }
    }
  }
}
</style>
